import {z} from '@hono/zod-openapi';

import {conversationParams} from '../../modules/conversation/conversationParams';
import {conversationEvent} from '../../modules/event/conversationEvent';

export const getUnreadEventsParams = conversationParams;

export type GetUnreadEventsParams = z.infer<typeof getUnreadEventsParams>;

export const getUnreadEventsQuery = z.object({
  userId: z.string().uuid().openapi({
    description: 'ID of the user to get unread events for',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
});

export type GetUnreadEventsQuery = z.infer<typeof getUnreadEventsQuery>;

export const getUnreadEventsResponse = z.array(conversationEvent);

export type GetUnreadEventsResponse = z.infer<typeof getUnreadEventsResponse>;
